import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 24px;
`;
export const Text = styled.div `
  margin-bottom: 20px;
  line-height: var(--font-line-height-400);
`;
export const SecondaryText = styled.div `
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
  margin-bottom: 12px;
`;
export const PerksContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
